import React from 'react';
import { motion } from 'framer-motion';
import {heroReveal} from "../animations/animations";


const AccountHeroBit = ({
                            title,
                            subtitle,
                            background = 'default',
                            children
                        }) => {
    const backgrounds = {
        default: 'bg-gradient-to-br from-pearl via-pearl to-nude/30',
        sage: 'bg-gradient-to-br from-sage/5 via-sage/10 to-transparent',
        champagne: 'bg-gradient-to-br from-champagne/5 via-champagne/10 to-transparent',
        pearl: 'bg-gradient-to-br from-pearl via-pearl/95 to-pearl/90'
    };

    return (
        <motion.div
            variants={heroReveal}
            initial="initial"
            animate="animate"
            className={`relative overflow-hidden rounded-3xl ${backgrounds[background]} p-8 md:p-12 lg:p-16 mb-8 md:mb-12`}
        >
            {/* Subtle Pattern Overlay */}
            <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0" style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239CAF96' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                    backgroundSize: '60px 60px'
                }} />
            </div>

            {/* Content */}
            <div className="relative z-10">
                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1, duration: 0.8 }}
                    className="font-heading text-4xl md:text-5xl lg:text-6xl font-light mb-4 text-charcoal"
                >
                    {title}
                </motion.h1>

                {subtitle && (
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.8 }}
                        className="text-charcoal/60 text-lg md:text-xl max-w-2xl"
                    >
                        {subtitle}
                    </motion.p>
                )}

                {children && (
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.8 }}
                        className="mt-8"
                    >
                        {children}
                    </motion.div>
                )}
            </div>

            {/* Decorative Elements */}
            <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
                className="absolute right-8 top-8 w-24 h-24 opacity-5"
            >
                <svg viewBox="0 0 100 100" className="w-full h-full text-sage">
                    <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="1" fill="none" />
                </svg>
            </motion.div>
        </motion.div>
    );
};

export default AccountHeroBit;